import { ThemeUICSSObject } from '@apia/theme';
import animations from '../../../rootStyles/animations';
/* IMPORT HERE */
export const history: ThemeUICSSObject = {
  /* PREPEND HERE */

  width: '100%',
  flexShrink: 1,
  height: 'calc(100vh - 300px)',
  minHeight: '25vh',
  flexGrow: 1,
  '.messages_box': { fontSize: '22px', minHeight: '88vh' },
  '.history_message': {
    borderRadius: '2px',
    px: 4,
    py: 5,
    maxWidth: '80%',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',

    '&.user': {
      borderRadius: 'chatMessage',
      borderTopRightRadius: '0px',
      backgroundColor: 'rgb(108 166 203)', //rgb(117 163 192)', //rgb(92, 143, 174)',
      color: 'white',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(113 145 193)',
      alignSelf: 'end',
      display: 'flex',
      flexDirection: 'column',
      // gap: '16px',
      width: 'max-content',
      '.additionalContent_wrapper': {
        display: 'flex',
        justifyContent: 'flex-end',
        '.labelBox': {
          width: 'max-content',
          background: '#fafafa',
          color: 'palette.text.primary',
          fontSize: '14px',
          '.labelAndIcon ': {
            fontSize: '14px',
          },
        },
      },
    },
    '&.system': {
      borderRadius: 'chatMessage',
      borderTopLeftRadius: '0px',
      backgroundColor: '#00bcff14',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(0 28 38 / 18%)',
    },

    '&.warning': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#ffff0024',
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(0 28 38 / 18%)',
    },

    '&.error': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#fd84212b',
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(0 28 38 / 18%)',
    },

    '&.information': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#00bcff14', //'#2222cc2b',
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(0 28 38 / 18%)',
    },
  },
  '.history': {
    animation: `${animations.fadeInFromBottom} 0.3s`,
    padding: '100px 32px 80px 32px',
    border: 'none',
    height: 'unset',
  },
  '.help__container': {
    borderRadius: '2px 20px 20px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  '.autoscrollContainer': {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 3,
    p: 3,
  },
};
